/**
 * Checks if the given value is a boolean primitive.
 */

export const isBoolean = (value: unknown) => typeof value === "boolean"
